import { render, staticRenderFns } from "./index-nor.vue?vue&type=template&id=33ea5e5c"
import script from "./index-nor.vue?vue&type=script&lang=tsx"
export * from "./index-nor.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports